import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaRocket,
  FaEye,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SocialMediaVideoAdsInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Social Media Video Ads in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Amplify Your Brand</Subheading>}
        heading={
          <Heading>
            Social Media <span tw="text-primary-500">Video Ads</span> in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we deliver professional social media video ads in
            **Dubai**, crafting targeted, engaging, and high-impact campaigns
            for platforms like Instagram, TikTok, YouTube, and Facebook. Our
            videos drive brand visibility, boost engagement, and generate leads
            with precision targeting and compelling storytelling.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1574717024453-e515679aff46?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media video production setup
          "https://images.unsplash.com/photo-1598550476439-6847785fcea6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Content creator filming
          "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media creative setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Campaign"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Social Media Video Ads in Dubai"
        description="We create video ads that captivate and convert."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Engaging Content",
            description: "High-quality, platform-optimized video ads.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Proven Expertise",
            description: "Trusted by brands across industries.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Results",
            description: "Quick campaign setup and delivery.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Precision Targeting",
            description: "Reach the right audience at the right time.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Custom Strategies",
            description: "Tailored to your brand’s goals.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Measurable ROI",
            description: "Trackable results with detailed analytics.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Social Media Video Ads Process"
        description={
          <Description>
            We craft high-impact video ad campaigns with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Understand your brand, audience, and goals.</li>
              <li>Strategy: Develop platform-specific ad strategies.</li>
              <li>Production: Create engaging, high-quality video content.</li>
              <li>Optimization: Use advanced targeting and analytics.</li>
              <li>Launch: Deploy campaigns across chosen platforms.</li>
              <li>Reporting: Provide detailed performance insights.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Mobile-first video editing
          "https://images.unsplash.com/photo-1551817958-d9d86fb29431?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional social media setup
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Creative team meeting
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Social Media Video Ad Wins in Dubai"
        description="Our campaigns have driven measurable results."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Campaign",
            description: "Achieved millions of views for a brand launch.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Lead Generation",
            description: "Boosted conversions for a Dubai retailer.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "97% approval from ad campaign clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Boost Your Brand?</Subheading>}
        heading="Social Media Video Ads in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for professional social media video ads
            in Dubai. Get targeted, high-impact campaigns that drive engagement
            and results—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Smartphone with social media apps
          "https://images.unsplash.com/photo-1572048572929-782ede5ee44b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape for social content
          "https://images.unsplash.com/photo-1533422902779-aff35862e462?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media content creation
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
